/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : profileReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import customConsole from "../../config/customConsole";
import actionType from "../actionTypes";
const initialState = {
  error: false,
  msg: "",
  profile: {},
  profile_pic_name: "",
  profile_pic_path: "",
};

const profileReducer = (state = initialState, action) => {
  customConsole(action);
  switch (action.type) {
    case actionType.GET_PROFILE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        profile: action.payload.data,
      };
    case actionType.GET_PROFILE_PIC:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        profile_pic_path: action.payload.file_path,
      };
    case actionType.UPLOAD_PROFILE_PIC:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        profile_pic_name: action.payload.file_name
          ? action.payload.file_name
          : "",
      };
    case actionType.UPDATE_PROFILE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        profile: action.payload,
      };
    case "UPDATE_PROFILE_PARTIAL":
      return {
        ...state,
        error: false,
        msg: action.payload.msg || "Profile updated successfully",
        profile: {
          ...state.profile,
          ...action.payload.data, // Merge only changed fields
        },
      };
    case actionType.RESET_PROFILE:
      return initialState;
    default:
      return state;
  }
};

export default profileReducer;
